module.exports = {"130104001":"东里街道","130104002":"中山街道","130104004":"南长街道","130104005":"维明街道","130104007":"友谊街道","130104008":"红旗街道","130104009":"新石街道","130104010":"苑东街道","130104011":"西里街道","130104012":"振头街道","130104013":"留营街道","130104014":"长兴街道","130104015":"彭后街道","130104016":"东风街道","130104017":"东华街道","130104018":"休门街道","130104019":"汇通街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130104.json
// module id = 143
// module chunks = 0